<div class="grid grid-cols-4 md:grid-cols-8 gap-1">
    <ng-template #filterOptions></ng-template>
</div>